import { ROUTE_TYPES } from '~/navigation/routes';
import {loadModelPath} from '~/actions/ui_actions';
import getConfig from '~/config';
import {changeAppPage, changeDialogPage, changePage, changeAppPageAction} from '~/actions/actions';
import identify from "~/identify";
import createConfirmNavigation from './createConfirmNavigation';
import createModelTreeHelper from "~/navigation/ensureModelTree";
import get from 'lodash/get';
import lexModelPathName from "~/navigation/helpers/lexModelPathName";
import set from 'lodash/fp/set';


const ROUTER_LOCATION_CHANGED = 'ROUTER_LOCATION_CHANGED';

const routeDispatcher = store => next => action => {
    let dispatch = store.dispatch;

    const notFound = () => {
        return dispatch(changeAppPage(identify.APP_PAGE_NOTFOUND));
    };

    const notAuthorized = () => {
        return dispatch(changeAppPage(identify.APP_PAGE_NOT_AUTHORIZED));
    };

    try {
        let config = getConfig();

        if(action.type !== ROUTER_LOCATION_CHANGED) {
            next(action);
            return;
        }

        let data = action.payload,
            type = get(action, 'payload.result.type', null);

        if(!type) { return notFound(); }

        const preparedAction = set(
            "payload.options",
            {
                ...action.payload.options,
                ...store.getState().router.goBackOptions
            },
            action
        )

        const confirmNavigation = createConfirmNavigation(store, preparedAction);
        const { ensurePathModelTree } = createModelTreeHelper({store, action: preparedAction});

        const ensureAppPage = () => {
            if(store.getState().page !== 'app') {
                dispatch(changePage('app'));
            }
        };

        const ensureModelAppPage = () => {
            ensureAppPage();

            if(store.getState().appPage !== identify.APP_PAGE_MODEL) {
                dispatch(changeAppPage(identify.APP_PAGE_MODEL));
            }
        };

        const ensureModelPageAction = () => {
            dispatch(changeAppPageAction(data.query?.action, data.query));
        };

        // if navigation is aborted we dont dispatch route related actions
        if (!confirmNavigation()) {
            next(action);
            return;
        }

        const execute = () => {
            switch (type) {
                case ROUTE_TYPES.INDEX:
                    let {page, appPage, model} = config.defaultPage;

                    dispatch(changePage(page));

                    if(page === identify.APP_PAGE) {
                        dispatch(changeAppPage(appPage, data));

                        if (appPage === identify.APP_PAGE_MODEL) {
                            const { pathname } = store.getState().router;
                            const hasPathChanged = data.pathname !== pathname || get(data.options, "forceChangeRootModel", false);
                            dispatch(loadModelPath(lexModelPathName(`/${model}`), hasPathChanged));
                        }
                    }
                    break;
                case ROUTE_TYPES.CHANGE_PAGE:
                    dispatch(changePage(data.result.page));
                    break;
                case ROUTE_TYPES.ALL_MODELS:
                case ROUTE_TYPES.EDIT_ENTRY:
                case ROUTE_TYPES.SUBVIEW:
                case ROUTE_TYPES.VIEW_ENRY:
                    ensureModelAppPage();
                    ensurePathModelTree();
                    break;
                case ROUTE_TYPES.CHANGE_APP_PAGE:
                    ensureAppPage();

                    const thePage = data.result.appPage;
                    switch(thePage) {
                        default:
                            dispatch(changeAppPage(data.result.appPage, data));
                            break;
                    }

                    break;
                default:
                    dispatch(changeAppPage(identify.APP_PAGE_NOTFOUND, data));
                    break;
            }

            ensureModelPageAction();
            dispatch(changeDialogPage(data.query.dialogPage));
            
        };

        let enclose = get(data, 'options.enclose', (e) => e());

        enclose(execute);

    } catch(err) {
        console.error('routeDispatcher error', err);
        dispatch(changeAppPage(identify.APP_PAGE_ERROR));
    }

    next(action);
};

export default routeDispatcher;